<template>
<el-date-picker
    v-model="date"
    :placeholder="'请选择'"
    :unlink-panels="true"
    size="small"
    :type="(type==='weekOnly')?'daterange':type==='dateOnly'?'date':'month'"
    range-separator="至"
    :picker-options="getOption"
    value-format="timestamp"
    clearable
    @change='(val)=>{setValue(val)}'
    @blur='handleBlur'
    :key="type==='weekOnly'?'pickerOnly1':type==='dateOnly'?'pickerOnly2':'pickerOnly3'"
>
</el-date-picker>
</template>
<script>

export default {
    name:"WeekDatePicker1",
    props:{
        type:{
            type:String,
            default:"date"
        },
        value:{
          type:Array||Date,
          default:""
        }
        
        
    },
    watch:{
        type:{
            handler(newVal,oldVal){
                if(newVal!=oldVal){
                    this.date = []
                }
               
            },
            deep:true,
            

        },
        value:{
          handler(newVal){
            this.date = _.cloneDeep(newVal)
          },
          deep:true,
          immediate:true
        }
    },
    created(){
        
    },
    computed:{   
      getOption(){
        let res = {}
        if(this.type==='weekOnly'){
          res = {
            onPick: (time) => {
              if (!time.minDate){
                this.timeStart = null
              }
              if (time.minDate && !time.maxDate) {
                this.timeOptionRange = time.minDate;
                this.timeStart = time.minDate
              }
              if (time.maxDate) {
                this.timeOptionRange = null;
              }
            },
            firstDayOfWeek:1,
            disabledDate: (time) => {
              let timeOptionRange = this.timeOptionRange;
              if(!this.timeStart){
                return time.getDay()!=1
              }else{
                if(timeOptionRange){
                  return time.getDay()!=0||time.getTime()<timeOptionRange.getTime()||time.getTime()>timeOptionRange.getTime()+518400000
                }
              }
              
            },
          }
        }else{
          res= {
            onPick: (time) => {
            },
            firstDayOfWeek:1,
            disabledDate: (time) => {
              
              
            },
          }
        }
        return res
      }
    },
    data(){
        return {
            date:[],
        }
    },
    methods:{
      handleBlur(){
        this.timeStart = null
      },
        setValue(val){
            this.$emit('input',val)
            this.$emit('change',val)
            this.timeStart = null
        }
    }
    
}
</script>